module.exports = __webpack_public_path__ + "img/venus6.a1a6dbb8.png";